import { Form, Radio } from 'antd';
import React from 'react';
import { RadioStyled } from 'page/Application/ManageProjectRegistration/component/FormRadio/styled';
import useStatusProject from 'hook/useStatusProject';
import {
  Grid1,
  Grid2,
} from 'page/Application/ManageProjectRegistration/component/styled';
import FormLabelGrid from 'page/Application/ManageProjectRegistration/component/FormLabelGrid';

const FormRadio = ({ name, onChange, required }) => {
  const { STATUS_FOR_FORM } = useStatusProject();
  return (
    <>
      <Grid1>
        <FormLabelGrid labelText={'ステータス'} required={false} />
      </Grid1>
      <Grid2>
        <Form.Item name={name} required={required}>
          <Radio.Group name="projectIsDisplayed" onChange={onChange}>
            <RadioStyled value={STATUS_FOR_FORM[0].value}>
              {STATUS_FOR_FORM[0].label}
            </RadioStyled>
            <RadioStyled value={STATUS_FOR_FORM[1].value}>
              {STATUS_FOR_FORM[1].label}
            </RadioStyled>
          </Radio.Group>
        </Form.Item>
      </Grid2>
    </>
  );
};
export default FormRadio;
